export default __webpack_public_path__ + "static/media/navbar-invoices-dark.f501f060.svg";